import { createIcon } from '@chakra-ui/react';

export const MbePasswordOff = createIcon({
  displayName: 'MbePasswordOff',
  viewBox: '0 0 38 38',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M0 0h20.303v13.876H0z" id="53nzxtgi6a" />
        <path d="M0 0h20.295v13.868H0z" id="uubzjyif8c" />
        <path d="M0 0h24.312v23.75H0z" id="vrn686xr6e" />
      </defs>
      <g fill="currentColor" fillRule="evenodd">
        <g transform="translate(3.563 10.916)">
          <mask fill="#fff" id="9a1wpryt5b">
            <use xlinkHref="#53nzxtgi6a" />
          </mask>
          <path
            d="M7.62 12.937C4.349 11.239 2.286 8.95 1.574 8.085c1.178-1.45 6.112-6.841 14.165-6.841 1.234 0 2.4.131 3.489.355L20.303.548A19.058 19.058 0 0 0 15.738 0C5.819 0 .472 7.413.248 7.732L0 8.085l.249.349c.14.199 2.323 3.233 6.41 5.442l.962-.94z"
            fill="#221E1F"
            mask="url(#9a1wpryt5b)"
          />
        </g>
        <g transform="translate(14.736 13.218)">
          <mask fill="#fff" id="x5dzhxo3dd">
            <use xlinkHref="#uubzjyif8c" />
          </mask>
          <path
            d="M20.048 5.43c-.141-.2-2.324-3.229-6.411-5.43l-.955.933c3.272 1.69 5.335 3.98 6.041 4.85-1.177 1.449-6.105 6.84-14.158 6.84-1.235 0-2.4-.13-3.49-.352L0 13.32a19.12 19.12 0 0 0 4.565.547c9.912 0 15.26-7.42 15.483-7.736l.247-.35-.247-.353z"
            fill="#221E1F"
            mask="url(#x5dzhxo3dd)"
          />
        </g>
        <path
          d="M19.3 14.648c.402 0 .784.05 1.153.15l1-.977a5.644 5.644 0 0 0-2.152-.417c-3.165 0-5.73 2.507-5.73 5.597 0 .741.146 1.456.426 2.103l1.006-.983a3.846 3.846 0 0 1-.159-1.12c0-2.4 2-4.353 4.457-4.353M19.3 23.355c-.401 0-.783-.05-1.152-.15l-1 .977c.663.274 1.39.417 2.153.417 3.157 0 5.73-2.512 5.73-5.598 0-.74-.147-1.455-.427-2.101l-1.006.982c.108.355.159.734.159 1.12 0 2.4-2 4.353-4.456 4.353"
          fill="#221E1F"
        />
        <g transform="translate(7.142 7.125)">
          <mask fill="#fff" id="xw2dkjedef">
            <use xlinkHref="#vrn686xr6e" />
          </mask>
          <path
            d="M24.125.182a.647.647 0 0 0-.9 0L.186 22.69a.612.612 0 0 0 0 .879.645.645 0 0 0 .9 0L24.125 1.062a.611.611 0 0 0 0-.88"
            fill="#221E1F"
            mask="url(#xw2dkjedef)"
          />
        </g>
      </g>
    </svg>
  ),
});
